import isNil from 'lodash/isNil';
import { GqlClient } from '@search/gql-client/src';
import { BuyableVasGqlEnum, OrderOfferVasOfferParam } from '@search/graphql-typings';
import { OrderOfferVasMutation$variables as OrderOfferVasMutationVariables, OrderOfferVasMutation$data as OrderOfferVasMutationResponse } from '../queries/__generated__/OrderOfferVasMutation.graphql';
import { OrderOfferVasMutation } from '../queries/OrderOfferVasMutation';

type OrderOfferVasServiceResult = {
    redirectUrl: string;
}

type IOrderOfferVasService = {
    gql: GqlClient;
    offersParams: OrderOfferVasOfferParam[];
    vases: BuyableVasGqlEnum[];
    durationDays: number;
    phone?: string;
    promocode?: string;
}

export const orderOfferVasService = ({
    gql, offersParams, vases, durationDays, phone, promocode
}: IOrderOfferVasService): Promise<OrderOfferVasServiceResult> => {
    return new Promise<OrderOfferVasServiceResult>((resolve, reject) => {
        gql.execute<OrderOfferVasMutationVariables, OrderOfferVasMutationResponse>(OrderOfferVasMutation, {
            offersParams,
            vases,
            durationDays,
            phone,
            promocode
        }).then(({ data, errors }) => {
            if (! isNil(errors) && errors.length > 0) {
                reject(errors);
            }

            if (! isNil(data?.orderOfferVas.bffError)) {
                const orderOfferVasError = data?.orderOfferVas.bffError;

                reject(orderOfferVasError);
            }

            resolve({
                redirectUrl: data?.orderOfferVas.redirectUrl ?? ''
            });
        }).catch(reject);
    });
};
